module.exports = __webpack_public_path__ + "img/form-sign.c3a83e4d.jpg";